export const GET_ALL_SYSTEMS_REQUEST = "GET_ALL_SYSTEMS_REQUEST";
export const GET_ALL_SYSTEMS_SUCCESS = "GET_ALL_SYSTEMS_SUCCESS";
export const GET_ALL_SYSTEMS_FAIL = "GET_ALL_SYSTEMS_FAIL";

export const GET_SYSTEM_BY_NAME_REQUEST = "GET_SYSTEM_BY_NAME_REQUEST";
export const GET_SYSTEM_BY_NAME_SUCCESS = "GET_SYSTEM_BY_NAME_SUCCESS";
export const GET_SYSTEM_BY_NAME_FAIL = "GET_SYSTEM_BY_NAME_FAIL";

export const ADD_SYSTEM_REQUEST = 'ADD_SYSTEM_REQUEST';
export const ADD_SYSTEM_SUCCESS = 'ADD_SYSTEM_SUCCESS';
export const ADD_SYSTEM_FAIL = 'ADD_SYSTEM_FAIL';
